export default "__VITE_ASSET__rhcotJXh__"